import * as React from 'react'
import styles from './Button.module.scss'
import classNames from 'classnames'
import { LoadingCircle } from 'components/LoadingCircle'

export interface ButtonProps {
	text?: string
	style?: any
	onClick?: any //: React.MouseEvent
	onBlur?: any //: React.MouseEvent
	width?: string
	className?: string
	disabled?: boolean
	id?: string
	variant?: string
	loading?: boolean
	loadingSpeed?: number
	html?: boolean
	children?: any
	ariaLabel?: string
	role?: string
	type?: 'button' | 'submit' | 'reset'
}

const ButtonComponent: React.FC<ButtonProps> = (props) => {
	const { style, text, onClick, className, disabled, id, loading, loadingSpeed, children, variant, ariaLabel, role, type, onBlur } = props
	let content = text
	if (children) {
		content = children
	}

	const _class = variant ? styles[`button_${variant}`] : styles.button
	const classes = classNames(_class, className, { disabled: disabled })

	return (
		<button
			className={classes}
			onClick={onClick}
			onBlur={onBlur}
			disabled={disabled}
			id={id}
			style={style}
			type={type}
			aria-label={ariaLabel || ''}
			role={role || ''}
		>
			{loading ? <LoadingCircle /> : content}
		</button>
	)
}

export default ButtonComponent
